import styled from "styled-components";

export const Wrap = styled.section`
  align-items: center;
  background-color: ${({ theme }) =>
    theme.discountMessage?.backgroundColor ?? "#cbf3f0"};
  display: flex;
  flex-direction: row;
  font-size: 16px;
  justify-content: space-between;
  line-height: 24px;
  margin-top: 10px;
  padding: 16px;
  white-space: nowrap;
  width: 100%;

  @media screen and (max-width: 482px) {
    flex-wrap: wrap;
  }
`;

export const Message = styled.div`
  align-items: center;
  display: flex;
  margin-right: 10px;

  & svg {
    margin-right: 10px;
    margin-top: 6px;
  }
`;

export const TotalPriceText = styled.div`
  @media screen and (max-width: 482px) {
    display: flex;
    margin-top: 8px;
  }
`;

export const PriceLabel = styled.div`
  font-weight: 600;
`;

export const StyledTotalPrice = styled.div`
  text-align: right;

  @media screen and (max-width: 482px) {
    margin: 0 3px;
  }

  & .value-element__value {
    font-weight: 600;
  }
`;
